import "../SCSS/stylesMobile.css";
import {
  EnumSurveyAnswerStatus,
  formulaTypes,
  formulaTypesMapping,
  MatrixTextFieldType,
  MatrixTypesEnum,
} from "../../../Common/Enums/EnumsTypes";
import { MatrixComponentProps, TOnWheelMatrix } from "../MatrixTypeProps";

function MatrixMobileView({
  surveyAnswersInfo,
  questionId,
  handleChangeCheckbox,
  surveyAnswers,
  handleChangeTextField,
  isPreview,
  handleChangeNumberField,
}: MatrixComponentProps) {
  const matrixInfo =
    surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[questionId]
      ?.matrixInfo;

  let inputStyle = (
    i: number,
    j: number
  ): {
    [key: string]: string | number;
  } => {
    return {
      border: "1px solid #0002",
      padding: "4px",
      outline: "none",
      textAlign: "center",
      width:
        matrixInfo?.colObj?.[matrixInfo.colOrder[j]]?.matrixType?.textType ===
        MatrixTextFieldType.SHORT
          ? "50px"
          : "100px",
    };
  };
  let inputStyleNumber: {
    [key: string]: string | number;
  } = {
    border: "1px solid #0002",
    padding: "4px",
    outline: "none",
    textAlign: "center",
    width: "50px",
    WebkitAppearance: "none",
    MozAppearance: "textfield",
  };
  return (
    <div className="mobile-supplier-view-matrix-cover">
      <div className="mobile-table-responsive">
        <table className="mobile-matrix-table">
          <thead>
            <tr>
              <th colSpan={matrixInfo?.colOrder.length! + 1}>
                {matrixInfo?.colName}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{matrixInfo?.rowName}</td>
              <thead>
                <tr>
                  <th></th>
                  {matrixInfo?.colOrder.map((colId) => (
                    <th key={colId}>
                      {matrixInfo?.colObj?.[colId]?.isMandatory && (
                        <span className="mandatory-fields">*</span>
                      )}
                      {matrixInfo?.colObj?.[colId]?.colLabel}
                      {matrixInfo.colObj?.[colId]?.matrixType?.name ===
                        MatrixTypesEnum.NUMBER &&
                        matrixInfo?.grandTotalInfo?.columns?.isEnabled &&
                        matrixInfo?.colObj?.[colId]?.colLabel &&
                        matrixInfo.colObj?.[colId]?.formulaInfo?.calcType! && (
                          <span className="formula-tag">
                            {
                              formulaTypesMapping[
                                matrixInfo.colObj?.[colId]?.formulaInfo
                                  ?.calcType!
                              ]
                            }
                          </span>
                        )}
                    </th>
                  ))}
                  {matrixInfo?.grandTotalInfo?.rows?.isEnabled && (
                    <th>Total</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {matrixInfo?.rowOrder.map((rowId, i) => (
                  <tr key={rowId}>
                    <td>
                      {matrixInfo?.rowObj?.[rowId]?.isMandatory && (
                        <span className="mandatory-fields">*</span>
                      )}
                      {matrixInfo?.rowObj?.[rowId]?.rowLabel}
                      {matrixInfo?.rowObj?.[rowId]?.rowLabel &&
                        matrixInfo?.grandTotalInfo?.rows?.isEnabled &&
                        matrixInfo.rowObj?.[rowId]?.formulaInfo?.calcType! && (
                          <span className="formula-tag">
                            {
                              formulaTypesMapping[
                                matrixInfo.rowObj?.[rowId]?.formulaInfo
                                  ?.calcType!
                              ]
                            }
                          </span>
                        )}
                    </td>
                    {matrixInfo?.colOrder.map((colId, j) => (
                      <td key={colId}>
                        {matrixInfo?.colObj?.[matrixInfo.colOrder[j]]
                          ?.matrixType?.name === MatrixTypesEnum.CHECKBOX ? (
                          <input
                            type="checkbox"
                            onChange={(event) =>
                              surveyAnswersInfo?.surveyStatus !==
                                EnumSurveyAnswerStatus?.COMPLETED &&
                              handleChangeCheckbox(
                                event,
                                questionId,
                                `${i}${j}`
                              )
                            }
                            checked={
                              surveyAnswers?.[questionId]?.val?.[`${i}${j}`]
                                ?.rowIndex === `${i}${j}`
                            }
                            // checked={
                            //   surveyAnswers[questionId] &&
                            //   `${i}${j}` in surveyAnswers[questionId].val
                            // }
                            disabled={isPreview}
                          />
                        ) : matrixInfo?.colObj?.[matrixInfo.colOrder[j]]
                            ?.matrixType?.name === MatrixTypesEnum.NUMBER ? (
                          <input
                            type="number"
                            style={inputStyleNumber}
                            className="input-number"
                            onWheel={(e: TOnWheelMatrix) => e.target.blur()}
                            onChange={(event) =>
                              surveyAnswersInfo?.surveyStatus !==
                                EnumSurveyAnswerStatus?.COMPLETED &&
                              handleChangeNumberField(
                                event,
                                questionId,
                                `${i}${j}`
                              )
                            }
                            value={
                              surveyAnswers?.[questionId]?.val?.[`${i}${j}`]
                            }
                            disabled={
                              isPreview ||
                              surveyAnswersInfo?.surveyStatus ===
                                EnumSurveyAnswerStatus?.COMPLETED
                            }
                          />
                        ) : (
                          <input
                            type="text"
                            style={inputStyle(i, j)}
                            className="mobile-input-text"
                            onChange={(event) =>
                              surveyAnswersInfo?.surveyStatus !==
                                EnumSurveyAnswerStatus?.COMPLETED &&
                              handleChangeTextField(
                                event,
                                questionId,
                                `${i}${j}`
                              )
                            }
                            value={
                              surveyAnswers?.[questionId]?.val?.[`${i}${j}`]
                            }
                            disabled={isPreview}
                            maxLength={
                              matrixInfo?.colObj?.[matrixInfo.colOrder[j]]
                                ?.matrixType?.textType ===
                              MatrixTextFieldType.SHORT
                                ? 10
                                : 50
                            }
                          />
                        )}
                      </td>
                    ))}
                    {matrixInfo?.grandTotalInfo?.rows?.isEnabled && (
                      <td>
                        {matrixInfo?.colOrder.some(
                          (colId) =>
                            matrixInfo.colObj?.[colId]?.matrixType?.name ===
                            MatrixTypesEnum.NUMBER
                        )
                          ? matrixInfo?.rowObj[rowId]?.formulaInfo
                              ?.grandTotalThreshold ??
                            (surveyAnswers?.[questionId]?.val?.[
                              `${i}${matrixInfo?.colOrder?.length}`
                            ] ||
                              0)
                          : "-"}
                      </td>
                    )}
                  </tr>
                ))}

                {matrixInfo?.grandTotalInfo?.columns?.isEnabled && (
                  <tr>
                    <td>Total</td>

                    {/* Empty cells for each column */}
                    {matrixInfo?.colOrder.map((colId, j) => (
                      <td key={colId}>
                        {matrixInfo.colObj?.[colId]?.matrixType?.name ===
                        MatrixTypesEnum.NUMBER
                          ? matrixInfo?.colObj[colId]?.formulaInfo
                              ?.grandTotalThreshold ??
                            (surveyAnswers?.[questionId]?.val?.[
                              `${matrixInfo?.rowOrder?.length}${j}`
                            ] ||
                              0)
                          : "-"}
                      </td>
                    ))}

                    {/* Add final Total column if rows.isEnabled is also true */}
                    {/* {matrixInfo?.grandTotalInfo?.rows?.isEnabled && (
                      <td>
                        {Object.values(totalsByRowAndColumn?.rowTotals).reduce(
                          (sum, val) => sum + val,
                          0
                        )}

                        {(() => {
                          const { rowTotals = {}, colTotals = {} } =
                            totalsByRowAndColumn || {};

                          let rowTotalSum = 0;
                          for (const rowKey in rowTotals) {
                            let val = Number(rowTotals[rowKey]) || 0;
                            const threshold =
                              matrixInfo?.rowObj?.[rowKey]?.formulaInfo
                                ?.grandTotalThreshold;
                            if (threshold) {
                              val = Number(threshold);
                            }

                            rowTotalSum += val;
                          }

                          let colTotalSum = 0;
                          for (const colKey in colTotals) {
                            let val = Number(colTotals[colKey]) || 0;
                            const threshold =
                              matrixInfo?.colObj[colKey]?.formulaInfo
                                ?.grandTotalThreshold;

                            if (threshold) {
                              val = Number(threshold);
                            }
                            colTotalSum += val;
                          }

                          const finalTotal = rowTotalSum + colTotalSum;
                          return finalTotal;
                        })()}
                      </td>
                    )} */}
                  </tr>
                )}
              </tbody>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MatrixMobileView;
